<template>
  <v-container
    id="detalhe-valor-vencido-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :cliente="enableClientes"
          :url="link"
        />
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="11"
                    >
                      <h3 class="text-center">
                        Relação de valores vencidos
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedNome(item.nome_reduzido)"
                                >
                                  {{ iconeNome }}
                                </v-icon>
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedQtdLancamento(item.qtd_lancamento)"
                                >
                                  {{ iconeLancamento }}
                                </v-icon>
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedDiasVencido(item.data_vencimento)"
                                >
                                  {{ iconeDataVencimento }}
                                </v-icon>
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela principal Fim -->
                      <!-- Tabela detalhe nome reduzido inicio -->
                      <div
                        v-if="expandNome"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoNome"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe nome reduzido Fim -->
                      <!-- Tabela detalhe quantidade de laçamento Inicio -->
                      <div
                        v-if="expandQtdLancamento"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoLancamento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe quantidade de laçamento Fim -->
                      <!-- Tabela detalhe data de vencimento Inicio -->
                      <div
                        v-if="expandVencimento"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoVencimento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe data de vencimento Fim -->
                      <!-- Tabela detalhe nome e lançamento inicio -->
                      <div
                        v-if="expandNomeLancamento"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosNomeLancamento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe nome e lançamento fim -->
                      <!-- Tabela detalhe nome e data vencimento inicio -->
                      <div
                        v-if="expandNomeData"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosNomeVencimento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe nome e data vencimento fim -->
                      <!-- Tabela detalhe nome, lançamento e data vencimento inicio -->
                      <div
                        v-if="expandNomeLancamentoData"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosNomeLancamentoVencimento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe nome, lançamento e data vencimento fim -->
                      <!-- Tabela detalhe lançamento e data de vencimento inicio -->
                      <div
                        v-if="expandLancamentoVencimento"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosLancamentoVencimento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 16%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 13%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela detalhe lançamento e data de vencimento Fim -->
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasVencidaDetalhamento',
    emits: [],
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: true,
      link: localStorage.linkContasReceber,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectCliente: [],
      headersDetalhamento: [
        { text: 'Nome reduzido', value: 'nome_reduzido', width: '200px', class: 'black--text title' },
        { text: 'Cod. lancamento', value: 'qtd_lancamento', width: '200px', class: 'black--text title' },
        { text: 'Data vencimento(dia)', value: 'data_vencimento', width: '200px', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', width: '130px', align: 'right', class: 'black--text title' },
        { text: 'Valor emissão', value: 'vlr_emissao', width: '130px', align: 'right', class: 'black--text title' },
        { text: 'Valor pago', value: 'vlr_pago', width: '130px', align: 'right', class: 'black--text title' },
        { text: 'Saldo', value: 'saldo', width: '130px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      dadosDetalhamentoNome: [],
      dadosDetalhamentoLancamento: [],
      dadosDetalhamentoVencimento: [],
      dadosLancamentoVencimento: [],
      dadosNomeLancamento: [],
      dadosNomeVencimento: [],
      dadosNomeLancamentoVencimento: [],
      respostaDetalhamentoLancamento: [],
      respostaDetalhamentoData: [],
      respostaDetalhamentoNome: [],
      respostaNomeLancamento: [],
      respostaNomeData: [],
      respostaLancamentoData: [],
      respostaNomeLancamentoData: [],
      expandNome: false,
      expandQtdLancamento: false,
      expandVencimento: false,
      expandNomeLancamento: false,
      expandNomeData: false,
      expandNomeLancamentoData: false,
      expandLancamentoVencimento: false,
      iconeNome: 'mdi-plus',
      iconeLancamento: 'mdi-plus',
      iconeDataVencimento: 'mdi-plus',
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.selectCliente = selectClientes

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []
        this.dadosDetalhamentoNome = []
        this.dadosDetalhamentoLancamento = []
        this.dadosDetalhamentoVencimento = []
        this.dadosLancamentoVencimento = []
        this.dadosNomeLancamento = []
        this.dadosNomeVencimento = []
        this.dadosNomeLancamentoVencimento = []

        this.respostaDetalhamentoLancamento = []
        this.respostaDetalhamentoData = []
        this.respostaDetalhamentoNome = []
        this.respostaNomeLancamento = []
        this.respostaNomeData = []
        this.respostaLancamentoData = []
        this.respostaNomeLancamentoData = []

        this.expandNome = false
        this.expandQtdLancamento = false
        this.expandVencimento = false
        this.expandNomeLancamento = false
        this.expandNomeData = false
        this.expandNomeLancamentoData = false
        this.expandLancamentoVencimento = false

        this.iconeNome = 'mdi-plus'
        this.iconeLancamento = 'mdi-plus'
        this.iconeDataVencimento = 'mdi-plus'

        this.showContasReceberDelhamentoValorVencido()
      },

      async showContasReceberDelhamentoValorVencido () {
        this.loading = true

        ContasReceber.showDelhamentoValorVencido(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectCliente).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                nome_reduzido: item.nome_reduzido,
                qtd_lancamento: item.qtd_lancamento,
                data_vencimento: item.data_vencimento,
                dias_vencido: item.dias_vencido,
                vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDetalhamento
            })

            this.showRespostaDetalhamentoLancamento(resposta.data.dadosDetalheLancamento)

            this.showRespostaDetalhamentoVencimento(resposta.data.dadosDetalheData)

            this.showRespostaDetalheNome(resposta.data.dadosDetalheNome)

            this.showRespostaNomeLancamento(resposta.data.dadosDetalheNomeLancamento)

            this.showRespostaNomeData(resposta.data.dadosDetalheNomeData)

            this.showRespostaLancamentoData(resposta.data.dadosDetalheLancamentoData)

            this.showRespostaNomeLancamentoData(resposta.data.dadosDetalheNomeLancamentoData)
          } else if (resposta.data.msg === 'Não há dados de recebimento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showRespostaDetalhamentoLancamento (dados) {
        try {
          this.respostaDetalhamentoLancamento = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Lançamento: ' + error)
        }
      },

      showRespostaDetalhamentoVencimento (dados) {
        try {
          this.respostaDetalhamentoData = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Lançamento Completo: ' + error)
        }
      },

      showRespostaDetalheNome (dados) {
        try {
          this.respostaDetalhamentoNome = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Nome: ' + error)
        }
      },

      showRespostaNomeLancamento (dados) {
        try {
          this.respostaNomeLancamento = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Nome/Lançamento: ' + error)
        }
      },

      showRespostaNomeData (dados) {
        try {
          this.respostaNomeData = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Nome/Data: ' + error)
        }
      },

      showRespostaLancamentoData (dados) {
        try {
          this.respostaLancamentoData = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Lançamento/Data: ' + error)
        }
      },

      showRespostaNomeLancamentoData (dados) {
        try {
          this.respostaNomeLancamentoData = dados.map((item) => {
            var listaDetalhamento = ({
              nome_reduzido: item.nome_reduzido,
              qtd_lancamento: item.qtd_lancamento,
              data_vencimento: item.data_vencimento,
              dias_vencido: item.dias_vencido,
              vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            })

            return listaDetalhamento
          })
        } catch (error) {
          this.showSnackbar('error', 3000, 'Erro ao montar dados Detalhe Nome/Lançamento/Data: ' + error)
        }
      },

      async expandedNome (value) {
        if (!this.expandNome) {
          this.iconeNome = 'mdi-minus'

          if (this.expandNomeLancamentoData && this.iconeLancamento === 'mdi-minus' && this.iconeDataVencimento === 'mdi-minus') {
            this.iconeNome = 'mdi-plus'
            this.expandNomeLancamentoData = false
            this.dadosNomeLancamentoVencimento = []
            this.dadosLancamentoVencimento = []
            this.expandLancamentoVencimento = true
            this.expandedLancamentoDiasVencido(value)
          } else if (this.expandNomeLancamento && this.iconeLancamento === 'mdi-minus') {
            this.expandNomeLancamento = false
            this.dadosNomeLancamento = []
            this.expandQtdLancamento = true
            this.iconeNome = 'mdi-plus'

            this.loading = true

            try {
              this.dadosDetalhamentoLancamento = this.respostaDetalhamentoLancamento
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.expandNomeData && this.iconeDataVencimento === 'mdi-minus') {
            this.expandNomeData = false
            this.dadosNomeVencimento = []
            this.expandVencimento = true
            this.iconeNome = 'mdi-plus'

            this.loading = true

            try {
              this.dadosDetalhamentoVencimento = this.respostaDetalhamentoData
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.iconeLancamento === 'mdi-minus' && this.iconeDataVencimento === 'mdi-minus') {
            this.expandedNomeLancamentoVencimento(value)
          } else if (this.iconeLancamento === 'mdi-minus') {
            this.expandedNomeLancamento(value)
          } else if (this.iconeDataVencimento === 'mdi-minus') {
            this.expandedNomeVencimento(value)
          } else {
            this.expandNome = true

            this.loading = true

            try {
              this.dadosDetalhamentoNome = this.respostaDetalhamentoNome
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          }
        } else {
          this.dadosDetalhamentoNome = []
          this.expandNome = false
          this.iconeNome = 'mdi-plus'
        }
      },

      async expandedQtdLancamento (value) {
        if (!this.expandQtdLancamento) {
          this.iconeLancamento = 'mdi-minus'

          if (this.expandNomeLancamentoData && this.iconeNome === 'mdi-minus' && this.iconeDataVencimento === 'mdi-minus') {
            this.iconeLancamento = 'mdi-plus'
            this.expandNomeLancamentoData = false
            this.dadosNomeLancamentoVencimento = []
            this.dadosNomeVencimento = []
            this.expandNomeData = true
            this.expandedNomeVencimento(value)
          } else if (this.expandNomeLancamento && this.iconeNome === 'mdi-minus') {
            this.iconeLancamento = 'mdi-plus'
            this.dadosNomeLancamento = []
            this.expandNomeLancamento = false
            this.expandQtdLancamento = false
            this.expandNome = true

            this.loading = true

            try {
              this.dadosDetalhamentoNome = this.respostaDetalhamentoNome
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.expandLancamentoVencimento && this.iconeDataVencimento === 'mdi-minus') {
            this.dadosLancamentoVencimento = []
            this.expandLancamentoVencimento = false
            this.expandQtdLancamento = false
            this.expandVencimento = true
            this.iconeLancamento = 'mdi-plus'

            this.loading = true

            try {
              this.dadosDetalhamentoVencimento = this.respostaDetalhamentoData
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.iconeNome === 'mdi-minus' && this.iconeDataVencimento === 'mdi-minus') {
            this.expandedNomeLancamentoVencimento(value)
          } else if (this.iconeNome === 'mdi-minus') {
            this.expandedNomeLancamento(value)
          } else if (this.iconeDataVencimento === 'mdi-minus') {
            this.expandedLancamentoDiasVencido(value)
          } else {
            this.dadosDetalhamentoNome = []
            this.expandQtdLancamento = true

            this.loading = true

            this.loading = true

            try {
              this.dadosDetalhamentoLancamento = this.respostaDetalhamentoLancamento
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          }
        } else {
          this.expandQtdLancamento = false
          this.iconeLancamento = 'mdi-plus'
          this.dadosDetalhamentoLancamento = []
        }
      },

      async expandedDiasVencido (value) {
        if (!this.expandVencimento) {
          this.iconeDataVencimento = 'mdi-minus'

          if (this.expandNomeLancamentoData && this.iconeNome === 'mdi-minus' && this.iconeLancamento === 'mdi-minus') {
            this.iconeDataVencimento = 'mdi-plus'
            this.expandNomeLancamentoData = false
            this.dadosNomeLancamentoVencimento = []
            this.dadosNomeLancamento = []
            this.expandNomeLancamento = true
            this.expandedNomeLancamento(value)
          } else if (this.expandNomeData && this.iconeNome === 'mdi-minus') {
            this.dadosNomeVencimento = []
            this.expandNomeData = false
            this.expandVencimento = false
            this.expandNome = true
            this.iconeDataVencimento = 'mdi-plus'

            this.loading = true

            try {
              this.dadosDetalhamentoNome = this.respostaDetalhamentoNome
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.expandLancamentoVencimento && this.iconeLancamento === 'mdi-minus') {
            this.dadosLancamentoVencimento = []
            this.expandLancamentoVencimento = false
            this.expandQtdLancamento = true
            this.expandVencimento = false
            this.iconeDataVencimento = 'mdi-plus'

            this.loading = true

            this.loading = true

            try {
              this.dadosDetalhamentoLancamento = this.respostaDetalhamentoLancamento
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          } else if (this.iconeNome === 'mdi-minus' && this.iconeLancamento === 'mdi-minus') {
            this.expandedNomeLancamentoVencimento(value)
          } else if (this.iconeNome === 'mdi-minus') {
            this.expandedNomeVencimento(value)
          } else if (this.iconeLancamento === 'mdi-minus') {
            this.expandedLancamentoDiasVencido(value)
          } else {
            this.expandVencimento = true

            this.loading = true

            try {
              this.dadosDetalhamentoVencimento = this.respostaDetalhamentoData
            } finally {
              setTimeout(() => {
                this.loading = false
              }, 500)
            }
          }
        } else {
          this.expandVencimento = false
          this.iconeDataVencimento = 'mdi-plus'
          this.dadosDetalhamentoNome = []
          this.dadosDetalhamentoLancamento = []
          this.dadosDetalhamentoVencimento = []
        }
      },

      async expandedNomeLancamento (value) {
        if (this.iconeNome === 'mdi-minus' && this.iconeLancamento === 'mdi-minus') {
          this.expandNomeLancamento = true
          this.expandNome = false
          this.expandQtdLancamento = false
          this.dadosDetalhamentoNome = []
          this.dadosNomeLancamento = []

          this.loading = true

          try {
            this.dadosNomeLancamento = this.respostaNomeLancamento
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },

      async expandedNomeVencimento (value) {
        if (this.iconeNome === 'mdi-minus' && this.iconeDataVencimento === 'mdi-minus') {
          this.dadosDetalhamentoNome = []
          this.dadosNomeVencimento = []

          this.expandNome = false
          this.expandVencimento = false
          this.expandNomeData = true

          this.loading = true

          try {
            this.dadosNomeVencimento = this.respostaNomeData
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },

      async expandedLancamentoDiasVencido (value) {
        if (this.iconeDataVencimento === 'mdi-minus' && this.iconeLancamento === 'mdi-minus') {
          this.dadosDetalhamentoLancamento = []
          this.dadosDetalhamentoVencimento = []
          this.dadosLancamentoVencimento = []

          this.expandQtdLancamento = false
          this.expandVencimento = false
          this.expandLancamentoVencimento = true

          this.loading = true

          try {
            this.dadosLancamentoVencimento = this.respostaLancamentoData
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },

      async expandedNomeLancamentoVencimento (value) {
        if (this.iconeNome === 'mdi-minus' && this.iconeLancamento === 'mdi-minus' && this.iconeDataVencimento === 'mdi-minus') {
          this.dadosDetalhamentoNome = []
          this.dadosDetalhamentoVencimento = []
          this.dadosLancamentoVencimento = []
          this.dadosDetalhamentoLancamento = []
          this.dadosDetalhamentoVencimento = []

          this.expandNome = false
          this.expandQtdLancamento = false
          this.expandVencimento = false
          this.expandNomeLancamento = false
          this.expandNomeData = false
          this.expandNomeLancamentoData = true

          this.loading = true

          try {
            this.dadosNomeLancamentoVencimento = this.respostaNomeLancamentoData
          } finally {
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #templateNome
    margin-left: -1rem

  #templateLancamento
    margin-left: -1rem

  #templateDataVencimento
    margin-left: -1rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
</style>
